function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 1c0-.552.716-1 1.6-1h28.8c.884 0 1.6.448 1.6 1s-.716 1-1.6 1H1.6C.716 2 0 1.552 0 1zm1.6 9c-.884 0-1.6.448-1.6 1s.716 1 1.6 1h28.8c.884 0 1.6-.448 1.6-1s-.716-1-1.6-1H1.6z",
  fill: "#243143"
});

function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAzMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDFDMCAwLjQ0NzcxNSAwLjcxNjM0NCAwIDEuNiAwSDMwLjRDMzEuMjgzNyAwIDMyIDAuNDQ3NzE1IDMyIDFDMzIgMS41NTIyOCAzMS4yODM3IDIgMzAuNCAySDEuNkMwLjcxNjM0NSAyIDAgMS41NTIyOCAwIDFaTTEuNiAxMEMwLjcxNjM0NCAxMCAwIDEwLjQ0NzcgMCAxMUMwIDExLjU1MjMgMC43MTYzNDUgMTIgMS42IDEySDMwLjRDMzEuMjgzNyAxMiAzMiAxMS41NTIzIDMyIDExQzMyIDEwLjQ0NzcgMzEuMjgzNyAxMCAzMC40IDEwSDEuNloiIGZpbGw9IiMyNDMxNDMiLz4KPC9zdmc+Cg==";
export { SvgBurger as ReactComponent };